import {Resource} from "../../api/resource";
import {BasicEntity, BasicProperty} from "../../basic-entity-back/annotations";
import {PropertyType} from "../../basic-entity-back/property-type/property-type";
import {PropertyMap, ReadWrite} from "../../basic-entity-back/basic-entity-interface/mapping-external";
import {Archivo} from "./archivo.model";

@BasicEntity({
    name: 'Archivo',
    endpoint: 'archivo_blender_primarias',
    isPaginated: true,
    paginationSizes: [20, 30, 50],
    type: "ArchivoBlenderPrimaria"
})
export class ArchivoBlenderPrimaria extends Archivo {
    public static readonly BLENDER_MAP: PropertyMap = {
        name: 'Blender Primaria',
        type: PropertyType.FutureUri('blender-primaria.model.ts'),
        readWrite: ReadWrite.ReadOnly
    }
    @BasicProperty(ArchivoBlenderPrimaria.BLENDER_MAP)
    private _blenderPrimaria;

    get blenderPrimaria() {
        return this._blenderPrimaria;
    }

    set blenderPrimaria(value) {
        this._blenderPrimaria = value;
    }
}
